module.exports = __webpack_public_path__ + "static/media/kazinoti-komenda.a99463ad.svg";